// 模型背景（「背景」分頁）：每個模型各自設定，存在後端 model 的
// colorSwitch + color（純色）、bgImageSwitch + bgImage（背景圖），發佈後 arviewer 依同一套規則顯示。
// 優先序：背景圖 > 純色 > 預設。判斷規則與 arviewer/src/utils/background.js 一致，改這裡要一起改。

export const BACKGROUND_MODES = ['default', 'color', 'image'];

// 編輯器預覽區原本的底色（預設模式維持不變）
export const EDITOR_DEFAULT_BACKGROUND = '#EEEEEE';

// 第一次切到「純色」時預先選的顏色：白色物件最常需要的是深色背景
export const INITIAL_PICK_COLOR = '#333333';

// 色票：淺到深，加幾個常見的商品攝影底色
export const COLOR_SWATCHES = ['#FFFFFF', '#F2F2F2', '#BDBDBD', '#757575', '#333333', '#000000', '#1F2A44', '#E8DCCB'];

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;

export const isValidHexColor = (value) => typeof value === 'string' && HEX_COLOR.test(value);

// 使用者輸入的色碼：容許少打 #、前後空白，轉成大寫；不合法回傳 null
export const normalizeHexInput = (value) => {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
    return isValidHexColor(withHash) ? withHash.toUpperCase() : null;
};

// 由後端 model 推出編輯器的背景狀態
export const getBackgroundStateFromModel = (model) => {
    const hasImage = typeof model?.bgImage === 'string' && model.bgImage.trim() !== '';
    const savedColor = isValidHexColor(model?.color) ? model.color.toUpperCase() : null;
    let mode = 'default';
    if (model?.bgImageSwitch === true && hasImage) mode = 'image';
    else if (model?.colorSwitch === true && savedColor) mode = 'color';
    // 沒開過純色的模型 color 是後端預設 #FFFFFF，對白色物件沒幫助，改給深灰當起始值
    const color = model?.colorSwitch === true && savedColor ? savedColor : (savedColor && savedColor !== '#FFFFFF' ? savedColor : INITIAL_PICK_COLOR);
    return {
        mode,
        color,
        bgImage: hasImage ? model.bgImage.trim() : '',
        pendingFile: null,
        previewUrl: '',
    };
};

// 儲存時送給 updateModel 的欄位（不含上傳圖片本身）
export const toUpdateModelBody = (state, uploadedImageUrl) => {
    const imageUrl = uploadedImageUrl || state.bgImage;
    return {
        color: isValidHexColor(state.color) ? state.color : INITIAL_PICK_COLOR,
        colorSwitch: state.mode === 'color',
        // 沒有圖可用時不能打開背景圖開關，否則 viewer 會拿到空網址
        bgImageSwitch: state.mode === 'image' && Boolean(imageUrl),
    };
};

// 預覽用的 CSS background；圖片優先用尚未上傳的本機預覽
export const toPreviewBackground = (state) => {
    if (state?.mode === 'image') {
        const url = state.previewUrl || state.bgImage;
        if (url) {
            const safeUrl = url.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
            return `${EDITOR_DEFAULT_BACKGROUND} url("${safeUrl}") center / cover no-repeat`;
        }
    }
    if (state?.mode === 'color' && isValidHexColor(state.color)) return state.color;
    return EDITOR_DEFAULT_BACKGROUND;
};
